<svg width="19" height="19" viewBox="-1.5 -1.5 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.334 12.6676V9.334M9.334 6.0004H9.34233M17.668 9.334C17.668 13.9367 13.9367 17.668 9.334 17.668C4.73126 17.668 1 13.9367 1 9.334C1 4.73126 4.73126 1 9.334 1C13.9367 1 17.668 4.73126 17.668 9.334Z" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
</svg>
